import { render } from "./MarriageEditDialog.vue?vue&type=template&id=38304019&scoped=true"
import script from "./MarriageEditDialog.vue?vue&type=script&lang=js"
export * from "./MarriageEditDialog.vue?vue&type=script&lang=js"

import "./MarriageEditDialog.vue?vue&type=style&index=0&id=38304019&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38304019"]])

export default __exports__